<ng-container *transloco="let t">
  <span class="block text-red text-xs pt-[5px] mt-[-17px]">
    {{ getText() }}
  </span>
</ng-container>
